
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import conf from "./../../config/base.js";
import axios from "axios";
import qs from "qs";
import {
invoiceTitleType,
discernStatus,
invoiceCheckStatus
} from "@/common/js/const";
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Box from 'vux/src/components/box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


import  scrollerEdit from '../invoice/scroller-edit'


export default {
directives: {
TransferDom
},
components: {
Box,
Group,
PopupPicker,
Datetime,
Scroller,
scrollerEdit,
Spinner,
Cell,
CellBox,
XHeader,
Loading,
Flexbox,
FlexboxItem
},
data() {
return {
showLoading: false,
groupFlag: "",
appKey: "",
mobilePhone: "",
period: 1,
isWechat: ____isWechatBrowser(),
showMonthPicker: false,
periodTypePickerValue: [],
monthList: [
[
{
name: "当月发票",
value: "1"
},
{
name: "上月发票",
value: "2"
}
]
],
showInvoiceStatusPicker: false,
StatusPickerValue: [],
invoiceStatusList: [
[
{
name: "已完成",
value: "1"
},
{
name: "处理中",
value: "0"
}
]
],
invoices: [],
scrollerHeight:
____invoiceScrollerHeight -
(this.$route.meta.showTabbar ? 55 : 0) +
"px",
scrollerStatus: {
pullupStatus: "default",
pulldownStatus: "default"
},
pullupEnabled: true,
scrollerPullupConfig: {
content: this.$t("上拉加载更多"),
downContent: this.$t("松开加载"),
upContent: this.$t("上拉加载更多"),
loadingContent: this.$t("加载中"),
height: 50,
autoRefresh: false
},
scrollerPulldownConfig: {
content: this.$t("下拉刷新"),
downContent: this.$t("松开刷新"),
upContent: this.$t("松开刷新"),
loadingContent: this.$t("加载中"),

height: 50,

autoRefresh: false
},
search: {
type: this.$t("月份"),
typeId: "1",
status: this.$t("开票状态"),
statusId: "1",
pageIndex: 1, //默认第一次请求第1页数据
pageSize: 10 
},
browserType: "mobile"
};
},
created() {},
activated() {
var $self = this;

$self.ACTION_setInvoiceIndexReload({
type: null,
reserve: ""
});

$self.browserType = ____browserRedirect();
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {
...mapState({
STATE_InvoiceIndexReload: state => state.invoice.invoiceIndexReload
})
},
filters: {},
/**初始化的时候调用  类似于 ready */
mounted() {
var $self = this;
$self.groupFlag = $self.$route.query.groupFlag;
$self.appKey = $self.$route.query.appKey;
$self.mobilePhone = $self.$route.query.mobilePhone;
$self.$nextTick(() => {
$self.$refs.scroller1.reset({ top: 0 });
});
$self.loadData(true);
},
methods: {
...mapActions({
ACTION_setPageLoadingTrue: "common_ac_setPageLoadingTrue"
}),
...mapActions({
ACTION_setPageLoadingFalse: "common_ac_setPageLoadingFalse"
}),
...mapActions({
ACTION_setInvoiceIndexReload: "invoice_ac_setinvoiceIndexReload"
}),

loadMore() {
var $self = this;
$self.loadData(false, function() {
setTimeout(() => {
$self.$refs.scroller1.donePullup();
}, 1200);
});
},

refresh() {
var $self = this;
$self.loadData(true, function() {
setTimeout(function() {
$self.$nextTick(() => {
setTimeout(() => {
$self.$refs.scroller1.donePulldown();
$self.pullupEnabled && $self.$refs.scroller1.enablePullup();
}, 10);
});
}, 1200);
});
},

loadData(firstLoad, callback) {
var $self = this;
if (firstLoad) {
$self.search.pageIndex = 1;
} else {
$self.search.pageIndex += 1;
}
var params = {
groupFlag: $self.groupFlag,
appKey: $self.appKey,
mobilePhone: $self.mobilePhone,
period: $self.search.typeId,
status: $self.search.statusId,
currentPage: $self.search.pageIndex,
pageNumber: $self.search.pageSize
};


$self.showLoading = true;
$self.$webapi.getInvoiceList(params).then(res => {
$self.$clog(res.data);
$self.showLoading = false;



if (res.data.header.code == 0) {
if (res.data.body.rows.length == 0) {


if (!firstLoad) {
$self.search.pageIndex--;
}
}
var tempInvoices = res.data.body.rows.map(function(el) {
let purchaserName = "购买方:";
if(el.purchaserName){
purchaserName = purchaserName + el.purchaserName;
}
if(!el.sellerName){
el.sellerName = "发票开具中"
}
var tempEl = {
__id: el.id,
topLeft: el.sellerName ? el.sellerName : "",
topRight: "￥" + el.amountWithTax,
middleLeft: purchaserName,
middleLeft2:
el.paperDrewDate == el.paperDrewDate
? "发票日期:" + $self.$formatDateTime3(el.paperDrewDate, "YYYY-MM-DD")
: "发票日期:",
status: el.status
};
if (el.invoiceType == "ce") {
tempEl.documentType = "30001001";
} else if (el.invoiceType == "c") {
tempEl.documentType = "20001002";
} else if (el.invoiceType == "s") {
tempEl.documentType = "10001001";
}
return tempEl;
});
if (firstLoad) {
$self.invoices = tempInvoices;
} else {
$self.invoices = $self.invoices.concat(tempInvoices);
}
} else {

if (!firstLoad) {
$self.search.pageIndex--;
}
}
$self.$nextTick(() => {
setTimeout(function() {
if (firstLoad) {
$self.$refs.scroller1.reset({ top: 0 });             } else {
$self.$refs.scroller1.reset(); 
}
}, 1000);
});

if (callback) {
callback();
}
});
},
changePullupStatus(enabled) {
var $self = this;
if (enabled) {
$self.$refs.scroller1.enablePullup();
$self.pullupEnabled = true;
} else {
$self.$refs.scroller1.disablePullup();
$self.pullupEnabled = false;
}
},
linkToDetail(invoice) {
var $self = this;
$self.$router.push({
path: "/orderinvoice/owtDetail/" + invoice.__id,
query: { appKey: $self.appKey, period: 1 }
});
},
onPeriodTypePickerChange(val) {
var $self = this;

$self.search.typeId = val[0];
$self.search.type = $self.monthList[0].filter(function(el) {
return el.value == $self.search.typeId;
})[0].name;

$self.loadData(true);
},

onInvoiceStatusPickerChange(val) {
var $self = this;
$self.search.statusId = val[0];
$self.search.status = $self.invoiceStatusList[0].filter(function(el) {
return el.value == $self.search.statusId;
})[0].name;

$self.loadData(true);
},

pageGoBack() {
var $self = this;
try {
if (____isAndroid) {
window.androidApi.backCalls();
} else {

window.iosApi.backCalls();
}
} catch (error) {

$self.$router.go(-1);
}
}
}
};
